
export const TJK_COUPON_STATUSES = {
  PLAYED: 'PLAYED',
  WON: 'WON',
  LOST: 'LOST',
  SAVED: 'SAVED'
};

export const TJK_COUPON_ENUMS = {
  PLAYED: 'Devam Eden',
  WON: 'Kazanan',
  LOST: 'Kaybeden',
  SAVED: 'Kayıtlı'
};

export const isTjkPlayDisable = () => {
  // const envValue = EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_content_view_switch' });
  //return !(EnvironmentManager.getMessageText({ key: 'tjk_content_view_switch' }) !== 'false');
  // bilyonerganyan-ng'de çalışıyor, bu yüzden her zaman enable (false döndür)
  return false;
};

export const TJK_URL_SUFFIX = {
  home: {
    fullPage: '/tjk',
    page: 'at-yarisi-anasayfa'
  },
  program: {
    fullPage: '/tjk/at-yarisi-bulteni',
    page: 'at-yarisi-bulteni',
    urlSuffix: '-at-yarisi-bulteni',
  },
  result: {
    fullPage: '/tjk/at-yarisi-sonuclari',
    page: 'at-yarisi-sonuclari',
    urlSuffix: '-at-yarisi-sonuclari',
  },
  agf: {
    fullPage: '/tjk/agf-tablosu',
    page: 'agf-tablosu',
    urlSuffix: '-agf-tablosu',
  },
  probables: {
    fullPage: '/tjk/muhtemeller',
    page: 'muhtemeller',
  },
  upcomingRaces: {
    fullPage: '/tjk/yaklasan-kosular',
    page: 'yaklasan-kosular',
  },
  reportedSuspendedJockeys: {
    fullPage: '/tjk/raporlu-cezali-jokeyler',
    page: 'raporlu-cezali-jokeyler'
  },
  author: {
    fullPage: '/tjk/at-yarisi-tahminleri',
    page: 'at-yarisi-tahminleri',
  },
  coupons: {
    fullPage: '/tjk/at-yarisi-kuponlarim',
    page: 'at-yarisi-kuponlarim',
  },
  shareCoupons: {
    fullPage: '/tjk/kupon-paylas',
    page: 'kupon-paylas',
  },
  sharedCoupon: {
    fullPage: '/tjk/kupon-paylas',
    page: 'paylasilan-kupon',
  },
  shareFixedOddCoupons: {
    fullPage: '/tjk/sabit-ihtimalli-kupon-paylas',
    page: 'sabit-ihtimalli-kupon-paylas',
  },
  sharedFixedOddCoupon: {
    fullPage: '/tjk/sabit-ihtimalli-kupon-paylas/kupon-paylas',
    page: 'paylasilan-sabit-ihtimalli-kupon',
  },
  horseCard: {
    fullPage: '/tjk/at-karti',
    page: 'at-karti'
  },
  runDetailWidget: {
    fullPage: '/tjk/yaris-detay',
    page: 'yaris-detay'
  },
  about: {
    fullPage: '/hakkinda',
    page: 'hakkinda'
  },
  tjkTv: {
    fullPage: '/tjk/tjk-tv-canli-izle',
    page: 'tjk-tv',
  },
  tjkTvExternal: {
    fullPage: '/tjk/tjk-tv-yurtdisi-izle',
    page: 'tjk-tv-yurtdisi',
  },
  fixedOdd: {
    fullPage: '/tjk/sabit-ihtimalli-at-yarisi-bulteni',
    page: 'sabit-ihtimalli-at-yarisi-bulteni',
    urlSuffix: '-sabit-ihtimalli-at-yarisi-bulteni',
  },
  virtualBet: {
    fullPage: '/sanal-bahis',
    page: 'sanal-bahis',
  },
  chanceGames: {
    fullPage: '/sans-oyunlari',
    page: 'sans-oyunlari',
  },
  scratchCard: {
    fullPage: '/kazi-kazan',
    page: 'kazi-kazan',
  },
  campaigns: {
    fullPage: '/kampanyalar',
    page: 'kampanyalar',
  },
};

export const PROGRAM_TYPES = {
  JOINT: 'JOINT',
  FIXED: 'FIXED'
};

export const FIXED_ODD_STATUS = {
  PLACEHOLDER: 'PLACEHOLDER',
  OPEN: 'OPEN',
  EACHWAY: 'EACHWAY',
  SUSPENDED: 'SUSPENDED',
  CLOSED: 'CLOSED',
  CLOSED_EARLY_SCRATCH: 'CLOSED_EARLY_SCRATCH',
  CLOSED_LATE_SCRATCH: 'CLOSED_LATE_SCRATCH',
  WON: 'WON',
  PLACED: 'PLACED',
  LOST: 'LOST',
  TIE: 'TIE',
  REFUNDED: 'REFUNDED',
  EARLY_SCRATCH: 'EARLY_SCRATCH',
  LATE_SCRATCH: 'LATE_SCRATCH',
};
